














































/** @format */
// eslint-disable-next-line no-unused-vars
import { Route } from 'vue-router';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { tabsChildren } from './routers';

const TAB_LIST = tabsChildren.map(it => ({ label: it.meta.title, value: it.name }));

interface IParkingIotTree {
  id: string;
  parentId: string;
  name: string;
  title: string;
  type: string;
  value: string;
  children?: [];
}

@Component({
  name: 'SettingManagement',
  components: {
    ParkingLotTreeLeft: () => import('@/components/parking-lot-tree-left/index.vue')
  }
})
export default class SettingManagement extends Vue {
  // 右栏tab配置
  currentTab = TAB_LIST[0].value;
  tabConfig = TAB_LIST;

  // 车场树选中的节点信息
  private parkingLotSelectedNodeInfo: any = {};
  private defaultExpandAll: boolean = true;
  private breadcrumbListData: IParkingIotTree[] = [];
  // 获得当前用户所属的车场信息
  @Getter('organizations/getUserParkingIotTree')
  parkingIotTree!: any[];
  @Getter('organizations/getUserOrgTreeFirstKeys')
  parkingIotFirstKeys!: any[];

  // 左右栏配置
  get flexColumns() {
    return [
      {
        id: 'tree',
        hiddenHeader: true,
        width: '300px',
        padding: '20px'
      },
      {
        id: 'setting-tab',
        padding: '0 30px 30px'
      }
    ];
  }

  get defaultSelectedKeys() {
    const { type, organizationId, parkId } = this;
    let keys: string[] = [];
    if (type === 'org' && organizationId !== '') {
      keys = [organizationId];
    } else if (type === 'park' && parkId !== '') {
      keys = [parkId];
    }
    this.breadcrumbListData = [];
    this.getBreadcrumbListData(keys[0], this.parkingIotTree, this.breadcrumbListData);
    this.breadcrumbListData = this.breadcrumbListData.reverse();
    return keys;
  }

  // Type
  @Prop({ type: String, default: 'org' })
  type!: string;

  // 机构ID
  @Prop({ type: String, default: '' })
  organizationId!: string;

  // 车场ID
  @Prop({ type: String, default: '' })
  parkId!: string;

  // 机构列表数据变化
  @Watch('parkingIotTree', { deep: true, immediate: true })
  onChangeParkingIotTree() {
    const { type, organizationId, parkId } = this;
    this.handleUpdateRoute({ type, organizationId, parkId });
  }

  // 监听选中的节点数据变化
  @Watch('parkingLotSelectedNodeInfo', { deep: true })
  onChangeParkingLotSelectedNodeInfo(newVal: any) {
    const { id, parentId, type } = newVal;
    let organizationId: string = '';
    let parkId: string = '';
    if (type === 'org') {
      organizationId = id;
      parkId = '';
    } else if (type === 'park') {
      organizationId = parentId;
      parkId = id;
    }
    this.$router.replace({
      name: this.$route.name,
      query: { type, organizationId, parkId }
    });
  }

  @Watch('$route', { deep: true })
  onChangeRoute(newVal: any) {
    for (let i = 0, len = this.tabConfig.length; i < len; i++) {
      if (this.tabConfig[i].value === newVal.name) {
        this.currentTab = newVal.name;
        (this.$refs.parkLotTreeLeft as any).clearSearch();
        break;
      }
    }
  }

  // Tab切换
  handleTabChange(v: string) {
    const { type, organizationId, parkId } = this;
    (this.$refs.parkLotTreeLeft as any).clearSearch();
    this.$router.push({
      name: v,
      query: {
        type,
        organizationId,
        parkId
      }
    });
  }

  /**
   * 获取面包屑列表数据
   * @param value
   * @param listData
   */
  private getBreadcrumbListData<T extends IParkingIotTree>(value: string, listData: T[], returnData: T[]): T[] {
    const newListData: T[] = [];
    listData.forEach((item: T) => {
      if (item.id === value) {
        newListData.push({
          ...item,
          children: []
        });
        returnData.push({
          ...item,
          children: []
        });
      } else {
        if (item.children && item.children.length) {
          const ab = this.getBreadcrumbListData(value, item.children, returnData);
          const obj = {
            ...item,
            children: ab
          };
          if (ab && ab.length) {
            newListData.push(obj);
            returnData.push(obj);
          }
        }
      }
    });
    return newListData;
  }

  // 点击面包屑跳转
  handleBreadcrumbChange(data: IParkingIotTree, index: number) {
    const { breadcrumbListData } = this;
    if (index < breadcrumbListData.length - 1) {
      const type = data.type || 'org';
      const organizationId = data.type && data.type === 'org' ? data.id : '';
      const parkId = data.type && data.type === 'park' ? data.id : '';
      this.$router.replace({
        name: this.$route.name,
        query: { type, organizationId, parkId }
      });
    }
  }

  // 左侧tree 节点选中
  handleParkingLotTreeNodeSelected(data: any) {
    this.parkingLotSelectedNodeInfo = {};
    let { node } = data.event;
    this.parkingLotSelectedNodeInfo = node.dataRef;
  }

  // 更新路由
  handleUpdateRoute(params: any) {
    let { type, organizationId, parkId } = params;
    const { parkingIotTree } = this;
    if (parkingIotTree.length > 0 && organizationId === '' && parkId === '') {
      organizationId = parkingIotTree[0]['id']; // 默认获取第一个节点
      this.$router.replace({
        name: this.$route.name,
        query: { type, organizationId, parkId }
      });
    }
  }

  created() {
    this.currentTab = this.$route.name as string;
  }

  mounted() {}

  beforeRouteEnter(to: Route, from: Route, next: any) {
    next();
  }

  beforeRouteUpdate(to: Route, from: Route, next: any) {
    let { type = 'org', organizationId = '', parkId = '' } = to.query;
    const { parkingIotTree } = this;
    if (parkingIotTree.length > 0 && organizationId === '' && parkId === '') {
      organizationId = parkingIotTree[0]['id']; // 默认获取第一个节点
      next({
        name: this.$route.name,
        query: { type, organizationId, parkId }
      });
    } else {
      next();
    }
  }
}
